import { Action } from '@ngrx/store';

export class XmAction<T> implements Action {
    public type: string;
    public payload?: T;
    public filters?: StoreFilters;
    public params?: ApiParams;
}

export enum StoreAction {
    // CALLBACK
    GET_CALLBACK_TIME = 'GET_CALLBACK_TIME',
    SUBMIT_CALLBACK_NUMBER = 'SUBMIT_CALLBACK_NUMBER',

    // CLEAR
    CLEAR_ON_SUBMIT = 'CLEAR_ON_SUBMIT',

    // CMS
    GET_ACTIVATION = 'GET_ACTIVATION',
    GET_ESIM_ACTIVATION = 'GET_ESIM_ACTIVATION',
    GET_ACTIVITY = 'GET_ACTIVITY',
    GET_BILLING_LANDING = 'GET_BILLING_LANDING',
    GET_BILLING_ADP = 'GET_BILLING_ADP',
    GET_BILLING_PAYMENT = 'GET_BILLING_PAYMENT',
    GET_BILLING_STATEMENT = 'GET_BILLING_STATEMENT',
    GET_BILLING_CREDIT = 'GET_BILLING_CREDIT',
    GET_BILLING_EXCHANGE_INSTRUCTION = 'GET_BILLING_EXCHANGE_INSTRUCTION',
    GET_CMS_USAGE_DETAIL = 'GET_CMS_USAGE_DETAIL',
    GET_RETURN_ORDER = 'GET_RETURN_ORDER',
    GET_EXCHANGE_ORDER = 'GET_EXCHANGE_ORDER',
    GET_CMS_ORDER_DETAIL = 'GET_CMS_ORDER_DETAIL',
    GET_CORE = 'GET_CORE',
    GET_DEVICES = 'GET_DEVICES',
    GET_DEVICE_RETURN = 'GET_DEVICE_RETURN',
    GET_DEVICE_UPGRADE = 'GET_DEVICE_UPGRADE',
    GET_DEVICE_SUSPEND = 'GET_DEVICE_SUSPEND',
    GET_DEVICE_CANCEL = 'GET_DEVICE_CANCEL',
    GET_DEVICE_ESIM_DOWNLOAD = 'GET_DEVICE_ESIM_DOWNLOAD',
    GET_CMS_PASSCODE_ENTRY = 'GET_CMS_PASSCODE_ENTRY',
    GET_ERRORS = 'GET_ERRORS',
    GET_NETWORK = 'GET_NETWORK',
    GET_INTERNATIONAL = 'GET_INTERNATIONAL',
    GET_CMS_USER_QUICKPAY = 'GET_CMS_USER_QUICKPAY',
    GET_CMS_AGENT_QUICKPAY = 'GET_CMS_AGENT_QUICKPAY',
    GET_CMS_QUICKPAY_ERRORS = 'GET_CMS_QUICKPAY_ERRORS',
    GET_CMS_QUICKPAY_BREADCRUMBS = 'GET_CMS_QUICKPAY_BREADCRUMBS',
    GET_SETTINGS = 'GET_SETTINGS',
    GET_LOGIN = 'GET_LOGIN',
    GET_HOP = 'GET_HOP',
    GET_DATA_DETAIL = 'GET_DATA_DETAIL',
    GET_ADDONS_PLANS = 'GET_ADDONS_PLANS',
    GET_CMS_INTERNATIONAL_TRAVEL = 'GET_CMS_INTERNATIONAL_TRAVEL',
    GET_CMS_INTERNATIONAL_CALLING = 'GET_CMS_INTERNATIONAL_CALLING',
    GET_CMS_CALL_FROM_US = 'GET_CMS_CALL_FROM_US',
    GET_ADDONS_DETAILS = 'GET_ADDONS_DETAILS',
    GET_ADDON_ERRORS = 'GET_ADDONS_ERRORS',
    GET_CMS_DATA_SAVER = 'GET_CMS_DATA_SAVER',
    GET_MY_ACCOUNT = 'GET_MY_ACCOUNT',
    GET_ACCOUNT_DATA_PLAN = 'GET_ACCOUNT_DATA_PLAN',
    GET_LINE_DATA_PLAN = 'GET_LINE_DATA_PLAN',
    GET_PLAN_SWITCH = 'GET_PLAN_SWITCH',
    GET_BUCKET_SWITCH = 'GET_BUCKET_SWITCH',
    GET_MY_ACCOUNT_MODALS = 'GET_MY_ACCOUNT_MODALS',
    GET_CONTACT_BAR = 'GET_CONTACT_BAR',
    GET_AB_TEST = 'GET_AB_TEST',
    GET_ONE_TIME_PAYMENT_CMS = 'GET_ONE_TIME_PAYMENT_CMS',
    GET_CMS_STATEMENT_LIST = 'GET_CMS_STATEMENT_LIST',
    CLEAR_ONE_TIME_PAYMENT = 'CLEAR_ONE_TIME_PAYMENT',
    GET_ADDITIONAL_DEVICE_PAYMENT_CMS = 'GET_ADDITIONAL_DEVICE_PAYMENT_CMS',
    GET_RETRY_PAYMENT_CMS = 'GET_RETRY_PAYMENT_CMS',
    GET_5G_PLAN_OVERVIEW = 'GET_5G_PLAN_OVERVIEW',
    GET_LEVEL_MOVE_START = 'GET_LEVEL_MOVE_START',
    GET_LEVEL_MOVE_ELIGIBILITY_CMS = 'GET_LEVEL_MOVE_ELIGIBILITY_CMS',
    GET_LEVEL_MOVE_IN_PROGRESS_CMS = 'GET_LEVEL_MOVE_IN_PROGRESS_CMS',
    GET_LEVEL_MOVE_SUCCESS_CMS = 'GET_LEVEL_MOVE_SUCCESS_CMS',
    GET_LEVEL_MOVE_PENDING_CMS = 'GET_LEVEL_MOVE_PENDING_CMS',
    GET_LEVEL_MOVE_ERROR_CMS = 'GET_LEVEL_MOVE_ERROR_CMS',
    GET_EXTENDED_PROMOS = 'GET_EXTENDED_PROMOS',
    GET_CMS_SIM_SWAP = 'GET_CMS_SIM_SWAP',
    GET_CMS_BYOD_EXCHANGE = 'GET_CMS_BYOD_EXCHANGE',
    GET_CMS_COUNTRY_CODE_MAPPING = 'GET_CMS_COUNTRY_CODE_MAPPING',
    GET_CMS_TRAVEL_RATES = 'GET_CMS_TRAVEL_RATES',
    GET_CMS_COMPATIBILITY_CHECK = 'GET_CMS_COMPATIBILITY_CHECK',
    GET_CMS_TRADE_IN_DEVICE = 'GET_CMS_TRADE_IN_DEVICE',
    GET_CMS_VIDEO_RESOLUTION = 'GET_CMS_VIDEO_RESOLUTION',
    GET_WATCHES = 'GET_WATCHES',
    
    // CREDIT CARD
    GET_CREDIT_CARD = 'GET_CREDIT_CARD',
    POST_CREDIT_CARD = 'POST_CREDIT_CARD',
    CLEAR_CREDIT_CARD = 'CLEAR_CREDIT_CARD',

    // HERO BANNER
    GET_HERO_BANNER_INFO = 'HERO_BANNER_INFO',
    CLEAR_HERO_BANNER_INFO = 'CLEAR_BANNER_INFO',

    // HOP
    GET_HOP_INIT = 'GET_HOP_INIT',

    // Cart
    GET_CART_COUNT = 'GET_CART_COUNT',
    GET_CART = 'GET_CART',

    // LINE
    GET_LINE_COLLECTION = 'GET_LINE_COLLECTION',
    CLEAR_LINE_COLLECTION = 'CLEAR_LINE_COLLECTION',
    GET_ACTIVATION_INFO_FOR_LINE = 'GET_ACTIVATION_INFO_FOR_LINE',
    GET_LINES_AND_ONE_ACTIVATION = 'GET_LINES_AND_ONE_ACTIVATION',
    GET_LINES_AND_ONE_ORDER_DETAIL = 'GET_LINES_AND_ONE_ORDER_DETAIL',
    GET_LINE_LEVEL_PLAN_ELIGIBILITY = 'GET_LINE_LEVEL_PLAN_ELIGIBILITY',
    POST_LEVEL_MOVE = 'POST_LEVEL_MOVE',
    GET_DATASAVER_STATUS = 'GET_DATASAVER_STATUS',
    UPDATE_DATASAVER_STATUS = 'UPDATE_DATASAVER_STATUS',
    GET_ACCOUNT_PLAN_ELIGIBILITY = 'GET_ACCOUNT_PLAN_ELIGIBILITY',
    UPDATE_ACTIVATION_INFO = 'UPDATE_ACTIVATION_INFO',
    POST_ACTIVATE_LINE = 'ACTIVATE_LINE',
    PERSIST_LINES = 'PERSIST_LINES',
    POST_DPP_PAYMENT = 'DPP_PAYMENT',
    UPDATE_DISPLAY_NAME = 'UPDATE_DISPLAY_NAME',
    GET_RETURN_ELIGIBILITY_COLLECTION = 'GET_RETURN_ELIGIBILITY_COLLECTION',
    CLEAR_RETURN_ELIGIBILITY = 'CLEAR_RETURN_ELIGIBILITY',
    CLEAR_LINE_LEVEL_PLAN_ELIGIBILITY = 'CLEAR_LINE_LEVEL_PLAN_ELIGIBILITY',
    GET_LINE_PROMOTIONS = 'GET_LINE_PROMOTIONS',
    GET_DEVICE_NETWORK_COMPATIBILITY = 'GET_DEVICE_NETWORK_COMPATIBILITY',
    GET_LINE_DEVICES = 'GET_LINE_DEVICES',
    POST_ALIGN_NETWORK_FEATURES = 'POST_ALIGN_NETWORK_FEATURES',
    CLEAR_LINE_DEVICES = 'CLEAR_LINE_DEVICES',
    CLEAR_ALIGN_NETWORK_FEATURES = 'CLEAR_ALIGN_NETWORK_FEATURES',
    GET_LINE_TRANSFER = 'GET_LINE_TRANSFER',
    GET_CMS_LINE_TRANSFER = 'GET_CMS_LINE_TRANSFER',
    GET_LINE_TRANSFER_BY_SESSION_ID = 'GET_LINE_TRANSFER_BY_SESSION_ID',
    REQUEST_NEW_PIN = 'REQUEST_NEW_PIN',
    GET_PENDING_LINE_TRANSFER = 'GET_PENDING_LINE_TRANSFER',
    CANCEL_LINE_TRANSFER = 'CANCEL_LINE_TRANSFER',
    POST_CANCEL_PLAN_SCHEDULED_DOWNGRADE = 'POST_CANCEL_PLAN_SCHEDULED_DOWNGRADE',
    POST_CHANGE_NOTIFICATION = 'POST_CHANGE_NOTIFICATION',
    SEND_PORT_OUT_PIN = 'SEND_PORT_OUT_PIN',
    SEND_OTP = 'SEND_OTP',
    GET_INSURANCE_ELIGIBILITY = 'GET_INSURANCE_ELIGIBILITY',
    
    // ESIM
    ESIM_CHANGE = 'ESIM_CHANGE',

    // NDEL
    GET_NDEL_ELIGIBILITY = 'GET_NDEL_ELIGIBILITY',
    GET_LINE_NDEL_ELIGIBILITY = 'GET_LINE_NDEL_ELIGIBILITY',
    CLEAR_NDEL_ELIGIBILITY = 'CLEAR_NDEL_ELIGIBILITY',
    CLEAR_LINE_NDEL_ELIGIBILITY = 'CLEAR_LINE_NDEL_ELIGIBILITY',

    // BYOD
    GET_BYOD_ELIGIBILITY = 'GET_BYOD_ELIGIBILITY',
    CLEAR_BYOD_ELIGIBILITY = 'CLEAR_BYOD_ELIGIBILITY',
    POST_LINES_DEVICES_BYOD_ORDER = 'POST_LINES_DEVICES_BYOD_ORDER',

    // LINE BANNER
    GET_LINE_BANNER_INFO = 'GET_LINE_BANNER_INFO',
    CLEAR_LINE_BANNER_INFO = 'CLEAR_LINE_BANNER_INFO',

    // ORDER
    GET_ORDER_DETAIL = 'GET_ORDER_DETAIL',
    DELETE_ORDER_DETAIL = 'DELETE_ORDER_DETAIL',
    CANCEL_ORDER = 'CANCEL_ORDER',
    ORDER_STATUS = 'ORDER_STATUS',

    // PAYMENT SUMMARY
    GET_PAYMENT_SUMMARY = 'GET_PAYMENT_SUMMARY',
    CLEAR_PAYMENT_SUMMARY = 'CLEAR_PAYMENT_SUMMARY',

    // Past Due
    GET_PAST_DUE = 'GET_PAST_DUE',
    CLEAR_PAST_DUE = 'CLEAR_PAST_DUE',
    POST_RETRY_PAYMENT = 'POST_RETRY_PAYMENT',
    SAVE_RETRY_PAYMENT_DATA = 'SAVE_RETRY_PAYMENT_DATA',
    GET_RETRY_PAYMENT_DATA = 'GET_RETRY_PAYMENT_DATA',
    CLEAR_RETRY_PAYMENT_DATA = 'CLEAR_RETRY_PAYMENT_DATA',
    CLEAR_RETRY_PAYMENT_RESULT = 'CLEAR_RETRY_PAYMENT_RESULT',

    // SUSPEND LINE
    SUSPEND_LINE = 'SUSPEND_LINE',
    SEND_PIN = 'SEND_PIN',

    // ADDONS
    GET_ADDONS_COLLECTION = 'GET_ADDONS_COLLECTION',
    CLEAR_ADDONS_COLLECTION = 'CLEAR_ADDONS_COLLECTION',
    ADD_ADDON = 'ADD_ADDON',
    REMOVE_ADDON = 'REMOVE_ADDON',
    CANCEL_REMOVE_ADDON = 'CANCEL_REMOVE_ADDON',

    // INTERNATIONAL RATES
    GET_INTERNATIONAL_RATES = 'GET_INTERNATIONAL_RATES',

    // REQUEST STATUS
    POLL_REQUEST_STATUS = 'POLL_REQUEST_STATUS',
    GET_REQUEST_STATUS = 'GET_REQUEST_STATUS',
    SWITCH_PLAN = 'SWITCH_PLAN',
    SWITCH_ACCOUNT_PLAN = 'SWITCH_ACCOUNT_PLAN',
    SAVE_REQUEST_RESULT = 'SAVE_REQUEST_RESULT',
    CLEAR_REQUEST_RESULT = 'CLEAR_REQUEST_RESULT',

    // STATEMENT
    GET_ESTIMATED = 'GET_ESTIMATED',
    GET_STATEMENT = 'GET_STATEMENT',
    CLEAR_STATEMENT = 'CLEAR_STATEMENT',
    GET_RELATED_STATEMENT_TRANSACTIONS = 'GET_RELATED_STATEMENT_TRANSACTIONS',
    GET_STATEMENT_LIST = 'GET_STATEMENT_LIST',
    CLEAR_STATEMENT_LIST = 'CLEAR_STATEMENT_LIST',
    CLEAR_RELATED_STATEMENT_TRANSACTIONS = 'CLEAR_RELATED_STATEMENT_TRANSACTIONS',
    CLEAR_ALL_RELATED_STATEMENT_TRANSACTIONS = 'CLEAR_ALL_RELATED_STATEMENT_TRANSACTIONS',
    GET_GTP_SESSION_COLLECTION = 'GET_GTP_SESSION_COLLECTION',
    CLEAR_RELATED_GTP_SESSION_COLLECTION = 'CLEAR_RELATED_GTP_SESSION_COLLECTION',
    CLEAR_ALL_GTP_SESSION_COLLECTION = 'CLEAR_ALL_GTP_SESSION_COLLECTION',

    // TRANSACTION
    GET_ORDERS = 'GET_ORDERS',
    CLEAR_ORDERS = 'CLEAR_ORDERS',
    GET_TRANSACTIONS_BY_PARAMS = 'GET_TRANSACTIONS_BY_PARAMS',
    CLEAR_TRANSACTION = 'CLEAR_TRANSACTION',

    // USAGE
    GET_USAGE_SUMMARY = 'GET_USAGE_SUMMARY',
    GET_USAGE_DETAIL = 'GET_USAGE_DETAIL',

    // USER
    GET_ALLOWED_LINES = 'ALLOWED_LINES',
    CLEAR_ALLOWED_LINES = 'CLEAR_ALLOWED_LINES',
    UPDATE_ACCOUNT_INFO = 'UPDATE_ACCOUNT_INFO',
    GET_ACCOUNT_INFO = 'ACCOUNT_INFO',
    GET_ACCOUNT_SUMMARY = 'ACCOUNT_SUMMARY',
    CLEAR_ACCOUNT_SUMMARY = 'CLEAR_ACCOUNT_SUMMARY',
    GET_BUY_INFO = 'GET_BUY_INFO',

    // Level Move
    GET_LEVEL_MOVE_ELIGIBILITY = 'GET_LEVEL_MOVE_ELIGIBILITY',

    // REASON CODES -- RETURNS AND CREDITS
    GET_REASON_CODES = 'GET_REASON_CODES',

    // DEVICE RETURN
    GET_FIND_MY_DEVICE_STATUS = 'GET_FIND_MY_DEVICE_STATUS',
    INITIATE_RETURN = 'INITIATE_RETURN',
    GET_DEVICE_RETURN_ELIGIBLE = 'GET_DEVICE_RETURN_ELIGIBLE',
    CLEAR_DEVICE_RETURN_ELIGIBLE = 'CLEAR_DEVICE_RETURN_ELIGIBLE',

    // PAYMENT
    POST_ONE_TIME_PAYMENT = 'POST_ONE_TIME_PAYMENT',
    SAVE_ONE_TIME_PAYMENT_DATA = 'SAVE_ONE_TIME_PAYMENT_DATA',
    GET_ONE_TIME_PAYMENT = 'GET_ONE_TIME_PAYMENT',
    SAVE_ADDITIONAL_DEVICE_PAYMENT_DATA = 'SAVE_ADDITIONAL_DEVICE_PAYMENT_DATA',
    GET_ADDITIONAL_DEVICE_PAYMENT = 'GET_ADDITIONAL_DEVICE_PAYMENT',
    POST_ADDITIONAL_DEVICE_PAYMENT = 'POST_ADDITIONAL_DEVICE_PAYMENT',
    CLEAR_ADDITIONAL_DEVICE_PAYMENT = 'CLEAR_ADDITIONAL_DEVICE_PAYMENT',

    // SMB COMING SOON
    GET_CMS_XMB_COMING_SOON = 'GET_CMS_XMB_COMING_SOON',
    GET_NAV_SEARCH_SUGGESTION = 'GET_NAV_SEARCH_SUGGESTION',
    GET_CMS_NON_XFINITY_CUSTOMER = 'GET_CMS_NON_XFINITY_CUSTOMER',

    // Activation OTP
    VERIFY_ACTIVATION_OTP_CB = 'VERIFY_ACTIVATION_OTP_CB',

    // Trade-In
    GET_TRADE_IN_OFFER_DATA = 'GET_TRADE_IN_OFFER_DATA',
    CANCEL_TRADE_IN_OFFER_DATA = 'CANCEL_TRADE_IN_OFFER_DATA',

    // VIDEO RESOLUTION
    GET_VIDEO_RESOLUTION = 'GET_VIDEO_RESOLUTION',
    POST_VIDEO_RESOLUTION = 'POST_VIDEO_RESOLUTION',

    // LOGGER
    POST_LOGGER = 'POST_LOGGER',

    // DISCOUNT PROMOTION
    GET_DISCOUNT_PROMOTION = 'GET_DISCOUNT_PROMOTION',

    // ESIM
    POST_DEVICE_ESIM_TRANSFER = 'POST_DEVICE_ESIM_TRANSFER',
    GET_ESIM_ORDER_STATUS = 'GET_ESIM_ORDER_STATUS',
    GET_CMS_ESIM = 'GET_CMS_ESIM',

    //NOW MOBILE
    GET_NOW_CORE = 'GET_NOW_CORE',
    GET_NOW_LANDING = 'GET_NOW_LANDING',
    GET_NOW_PLANS = 'GET_NOW_PLANS',
    GET_NOW_LINES = 'GET_NOW_LINES',
    GET_NOW_DEVICE_DETAILS = 'GET_NOW_DEVICE_DETAILS',
    GET_NOW_PAYMENTS = 'GET_NOW_PAYMENTS',
    GET_NOW_MODALS = 'GET_NOW_MODALS',
    GET_NOW_ACCOUNT_SUMMARY = 'GET_NOW_ACCOUNT_SUMMARY',
    CLEAR_NOW_ACCOUNT_SUMMARY = 'CLEAR_NOW_ACCOUNT_SUMMARY',
    GET_NOW_LINE_COLLECTION = 'GET_NOW_LINE_COLLECTION',
    CLEAR_NOW_LINE_COLLECTION = 'CLEAR_NOW_LINE_COLLECTION',
    GET_NOW_LINE_DEVICES = 'GET_NOW_LINE_DEVICES',
    CLEAR_NOW_LINE_DEVICES = 'CLEAR_NOW_LINE_DEVICES',
    GET_NOW_RETURN_EXCHANGE = 'GET_NOW_RETURN_EXCHANGE',
    GET_NOW_MORE_OPTIONS = 'GET_NOW_MORE_OPTIONS',
    GET_NOW_NUMBER_LOCK = 'GET_NOW_NUMBER_LOCK',
    GET_NOW_STEP_UP_AUTH = 'GET_NOW_STEP_UP_AUTH',
    GET_NOW_ESIM = 'GET_NOW_ESIM',
    GET_NOW_LINE_DETAILS = 'GET_NOW_LINE_DETAILS',
    GET_NOW_DEVICES = 'GET_NOW_DEVICES',
    CLEAR_NOW_DEVICES = 'CLEAR_NOW_DEVICES',
    GET_NOW_BILLING_SUMMARY = 'GET_NOW_BILLING_SUMMARY',
    GET_NOW_MOBILE_LANDING = 'GET_NOW_MOBILE_LANDING',
    GET_NOW_DATA_USAGE = 'GET_NOW_DATA_USAGE',
    CLEAR_NOW_MOBILE_LANDING = 'CLEAR_NOW_MOBILE_LANDING',
    GET_NOW_NOTIFICATION_BANNER_COLLECTION = 'GET_NOW_NOTIFICATION_BANNER_COLLECTION',
    GET_NOW_LINE_BADGES = 'GET_NOW_LINE_BADGES',
    GET_NOW_ACCOUNT_BADGES = 'GET_NOW_ACCOUNT_BADGES',
    POST_NOW_UPDATE_NICK_NAME = 'POST_NOW_UPDATE_NICK_NAME',
    GET_NOW_ESIM_ACTIVATION = 'GET_NOW_ESIM_ACTIVATION',
    GET_NOW_ESIM_ACTIVATION_STATUS = 'GET_NOW_ESIM_ACTIVATION_STATUS',
    GET_NOW_PAUSE_CANCEL_PORT = 'GET_NOW_PAUSE_CANCEL_PORT',
    GET_NOW_LINE_AUTO_PAY = 'GET_NOW_LINE_AUTO_PAY',
    POST_SALES_INTENT = 'POST_SALES_INTENT',
    POST_LINE_LOCK =  'POST_LINE_LOCK',
    GET_NOW_LINE_LOCK_AUTH_CHECK = 'GET_NOW_LINE_LOCK_AUTH_CHECK',
    GET_USER_INFO = 'GET_USER_INFO',
    POST_NIFI_SERVICE = 'POST_NIFI_SERVICE',
    POST_NOW_PORT_OUT_SEND_PIN = 'POST_NOW_PORT_OUT_SEND_PIN',
    GET_NOW_PORT_OUT_CHANGE_NOTIFY = 'GET_NOW_PORT_OUT_CHANGE_NOTIFY',
    GET_NOW_PORT_OUT_AUTH_CHECK = 'GET_NOW_PORT_OUT_AUTH_CHECK',
    STEP_UP_LINE_LOCK = 'STEP_UP_LINE_LOCK',
    STEP_UP_PORT_OUT = 'STEP_UP_PORT_OUT',
    STEP_UP_ADD_INSTRUMENT = 'STEP_UP_ADD_INSTRUMENT',
    GET_NOW_XM_UPGRADE_DATA = 'GET_NOW_XM_UPGRADE_DATA',
    STEP_UP_UPDATE_CONTACT = 'STEP_UP_UPDATE_CONTACT',
  
    //LINE LOCK
    GET_LINE_LOCK_STATUS = 'GET_LINE_LOCK_STATUS',
    POST_ENABLE_LINE_LOCK = 'ENABLE_LINE_LOCK',
    POST_DISABLE_LINE_LOCK = 'DISABLE_LINE_LOCK',

    //Breeze
    POST_BREEZE = 'POST_BREEZE',

    // CBM Broadband Label
    GET_BROADBAND_LABELS = 'GET_BROADBAND_LABELS'
}
